import React from 'react';
import { Calendar as CalendarIcon, UserX } from 'lucide-react';

export default function TeamCalendar({ holidays }) {
  // We only care about approved holidays that are in the future or currently ongoing
  const today = new Date();
  today.setUTCHours(0,0,0,0);

  const upcomingLeaves = holidays
    .filter(h => h.status === 'approved')
    .filter(h => {
      const end = new Date(h.endDate);
      end.setUTCHours(0,0,0,0);
      return end >= today;
    })
    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

  if (upcomingLeaves.length === 0) {
    return (
      <div className="card" style={{ marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '1.1rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CalendarIcon size={18} color="var(--primary-500)" />
          Who's Out
        </h3>
        <div style={{ padding: '24px', textAlign: 'center', color: 'var(--text-muted)' }}>
          <UserX size={32} style={{ opacity: 0.5, marginBottom: '8px' }} />
          <p>No team members are scheduled to be away.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card" style={{ marginBottom: '24px' }}>
      <h3 style={{ marginBottom: '16px', fontSize: '1.1rem', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
        <CalendarIcon size={18} color="var(--primary-500)" />
        Who's Out
      </h3>
      <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
        {upcomingLeaves.map(leave => {
          const start = new Date(leave.startDate);
          const end = new Date(leave.endDate);
          const isOngoing = start <= today && end >= today;

          return (
            <div key={leave.id} style={{ 
              padding: '12px', 
              border: `1px solid ${isOngoing ? 'var(--accent-emerald)' : 'var(--border-color)'}`,
              background: isOngoing ? 'rgba(16, 185, 129, 0.05)' : 'var(--bg-secondary)',
              borderRadius: '8px'
            }}>
              <div style={{ fontWeight: 600, color: 'var(--text-primary)', marginBottom: '4px' }}>
                {leave.employeeName}
              </div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '8px', textTransform: 'capitalize' }}>
                {leave.type.replace('_', ' ')} • {leave.durationDays} days {leave.isHalfDay ? '(Half Day)' : ''}
              </div>
              <div style={{ fontSize: '0.85rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <CalendarIcon size={14} color={isOngoing ? 'var(--accent-emerald)' : 'var(--text-muted)'} />
                <span style={{ color: isOngoing ? 'var(--accent-emerald)' : 'inherit', fontWeight: isOngoing ? 600 : 400 }}>
                  {isOngoing ? 'Currently Away' : `${leave.startDate} to ${leave.endDate}`}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
